/* eslint-disable react/prop-types */
import { useState } from 'react';
import Image from 'next/image';
import { string } from 'prop-types';
import Youtube from 'react-youtube';

import AgeRangePrograms from '#components/Vacation/age-range-programs';
import { ButtonComponent, Icon } from '#atoms/index';
import { useWindowSize } from '#hooks/index';
import { Button, H1, Paragraph } from '#styleguide/index';

const JumbutronUpd = ({
  variant,
  subtitle,
  title,
  titleColor,
  description,
  imgDesk,
  mainColor,
  breadcrumbs,
  learningPaths,
  setCurrentPill,
  setCurrentPillLevel,
  videoId,
  degrade,
  imgDeskDeg,
  colorImgDeskDeg,
  firstButton,
  secondButton,
  isPrivateClass,
  isVacationPage = false,
  dataPrograms,
  myRef,
  myRef1,
  myRef2,
  setIdButton,
  onClickRefContact
}) => {
  const { width } = useWindowSize();
  const [isPlay, setIsPlay] = useState(false);

  const onClickPlay = e => {
    setIsPlay(!isPlay);
    e.preventDefault();
  };
  const onClickCurrentPill = e => {
    if (variant === 'curso') {
      setCurrentPill(1);
    } else {
      setCurrentPillLevel(0);
      setCurrentPill(1);
    }
    e.preventDefault();

    if (width <= 470) {
      return window.scroll({ top: 1050, left: 0, behavior: 'smooth' });
    } else if (width <= 500) {
      return window.scroll({ top: 900, left: 0, behavior: 'smooth' });
    } else if (width < 768) {
      return window.scroll({ top: 890, left: 0, behavior: 'smooth' });
    } else if (width < 895) {
      return window.scroll({ top: 1050, left: 0, behavior: 'smooth' });
    } else if (width < 1024) {
      return window.scroll({ top: 1020, left: 0, behavior: 'smooth' });
    } else if (width < 1300) {
      return window.scroll({ top: 670, left: 0, behavior: 'smooth' });
    } else return window.scroll({ top: 620, left: 0, behavior: 'smooth' });
  };

  return (
    <div
      className="jumbutronUpd-container"
      style={{ background: variant === 'curso' ? '#ffffff' : degrade }}
    >
      <div className="jumbutronUpd-content">
        {/* Information */}
        <div className="jumbutronUpd-first-section">
          {/* Subtitle */}
          {subtitle && (
            <>
              <Paragraph
                className="jumbutronUpd-subtitle"
                size="21"
                /* weight="400" */
                color={variant === 'curso' ? mainColor : '#000000'}
              >
                {subtitle}
              </Paragraph>
            </>
          )}

          {/* Breadcrumbs */}
          {breadcrumbs}

          {/* {width >= 1007 && learningPaths?.length > 0 ? (
            <h3
              style={{
                display: variant === 'curso' ? 'flex' : 'none',
              }}
            >
              {learningPaths[0]?.courses[0]?.name === title
                ? 'Primer curso de la ruta '
                : 'Curso de la ruta '}
              {learningPaths[0]?.name}
            </h3>
          ) : null} */}

          {/* Title */}
          <H1
            color={variant === 'curso' ? mainColor : '#000000'}
            className="animation-title-bottom-top"
          >
            {title}{' '}
            {titleColor && (
              <>
                <br />
                <span style={{ color: mainColor }}>{titleColor}</span>
              </>
            )}
          </H1>

          {/* Description */}
          <Paragraph className="jumbutronUpd-description" size="16" /* weight="400" */>
            {description}
          </Paragraph>

          {/* First button */}
          {isVacationPage && (
            <div className="jumbutronUpd-content-vacation">
              <Button align="left" onClick={onClickRefContact}>
                ¡Quiero saber más!
              </Button>
              <AgeRangePrograms
                dataPrograms={dataPrograms}
                myRef={myRef}
                myRef1={myRef1}
                myRef2={myRef2}
                setIdButton={setIdButton}
              />
            </div>
          )}

          {/* Button container */}
          <div className="jumbutronUpd-buttons-container">
            {/* Video */}
            <ButtonComponent
              description="Mira el video"
              mainColor={mainColor}
              variantButton="outlined"
              onClick={onClickPlay}
            />

            {/* Private */}
            {isPrivateClass ? (
              <ButtonComponent
                description="Comprar"
                mainColor={mainColor}
                variantPage={variant}
                iconWhite="/icons/shopping-cart-white.svg"
                iconBlack="/icons/shopping-cart-black.svg"
                download={false}
                external={true}
                href={`https://wa.me/17867892469?text=¡Hola! Me gustaria saber más sobre las clases privadas`}
              />
            ) : (
              <>
                {/* Curso */}
                {variant === 'curso' ? (
                  <ButtonComponent
                    description="Comprar"
                    mainColor={mainColor}
                    variantPage={variant}
                    iconWhite="/icons/shopping-cart-white.svg"
                    iconBlack="/icons/shopping-cart-black.svg"
                    onClick={onClickCurrentPill}
                  />
                ) : (
                  <ButtonComponent
                    description="Comprar"
                    mainColor={mainColor}
                    variantPage={variant}
                    variantButton="black"
                    iconWhite="/icons/shopping-cart-white.svg"
                    iconBlack="/icons/shopping-cart-black.svg"
                    onClick={onClickCurrentPill}
                  />
                )}
              </>
            )}
          </div>

          {/* Show first button */}
          {firstButton && (
            <div className="jumbutronUpd-buttons-container-tech">
              {firstButton}
              {secondButton && <>{secondButton}</>}
            </div>
          )}
        </div>

        {/* Image */}
        <div className="jumbutronUpd-second-section">
          {isVacationPage && imgDesk ? (
            <img
              src={imgDesk}
              alt={`Curso de ${title} | Crack The Code`}
              width={564}
              height={572}
            />
          ) : imgDesk ? (
            <img
              src={imgDesk}
              alt={`Curso de ${title} | Crack The Code`}
              width={356}
              height={324}
            />
          ) : imgDeskDeg ? (
            <div style={{ background: colorImgDeskDeg }}>
              <Image
                src={imgDeskDeg}
                alt={`${title} | Crack The Code`}
                width={488}
                height={488}
              />
            </div>
          ) : null}
        </div>
      </div>

      {/* Video */}
      {isPlay && (
        <div className="feature-video-tile-modal active">
          <button onClick={() => setIsPlay(false)}>
            <Icon icon="clear" />
          </button>
          <Youtube
            videoId={videoId}
            id={`video-${videoId}`}
            opts={{ playerVars: { controls: 0, rel: 0 } }}
          />
        </div>
      )}
    </div>
  );
};

JumbutronUpd.propTypes = {
  title: string,
  mainColor: string
};

export default JumbutronUpd;
